import { render, staticRenderFns } from "./EChartFaltasAluno.vue?vue&type=template&id=a0822c38&scoped=true"
import script from "./EChartFaltasAluno.vue?vue&type=script&lang=js"
export * from "./EChartFaltasAluno.vue?vue&type=script&lang=js"
import style0 from "./EChartFaltasAluno.vue?vue&type=style&index=0&id=a0822c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0822c38",
  null
  
)

export default component.exports